import { useNavigate, useLocation } from 'react-router-dom';
import { Sparkles, MessageSquare } from 'lucide-react';
import { useBetaStatus } from '@/hooks/useBetaStatus';
import { Button } from '@/components/ui/button';

export function BetaBanner() {
  const { data: betaStatus, isLoading } = useBetaStatus();
  const navigate = useNavigate();
  const location = useLocation();

  // Debug logging
  console.log('[BetaBanner] Render - isLoading:', isLoading, 'betaStatus:', betaStatus, 'path:', location.pathname);

  // Don't show anything while loading
  if (isLoading) {
    console.log('[BetaBanner] Not showing - still loading');
    return null;
  }

  // Only show banner if user is in beta and program is active
  if (!betaStatus?.isInBeta || !betaStatus?.isActive) {
    console.log('[BetaBanner] Not showing - isInBeta:', betaStatus?.isInBeta, 'isActive:', betaStatus?.isActive);
    return null;
  }

  // Hide on onboarding and paywall pages
  const hiddenRoutes = ['/onboarding', '/paywall', '/payment-checkout', '/payment-success'];
  if (hiddenRoutes.some(route => location.pathname.startsWith(route))) {
    console.log('[BetaBanner] Not showing - hidden route:', location.pathname);
    return null;
  }

  console.log('[BetaBanner] Showing banner');

  const handleFeedbackClick = (e: React.MouseEvent) => {
    e.preventDefault();
    navigate('/beta-hub?tab=feedback');
  };

  const handleBetaHubClick = () => {
    navigate('/beta-hub');
  };

  return (
    <div className="bg-gradient-to-r from-purple-500/10 via-purple-400/5 to-transparent border-b border-purple-500/20 py-2 px-4">
      <div className="flex items-center justify-between max-w-7xl mx-auto">
        <div className="flex items-center gap-2">
          <Sparkles className="w-4 h-4 text-purple-500" />
          <span className="text-sm font-medium text-purple-700 dark:text-purple-300">
            Beta Tester
          </span>
        </div>
        <div className="flex items-center gap-2">
          <Button
            variant="ghost"
            size="sm"
            onClick={handleFeedbackClick}
            className="text-xs text-purple-600 dark:text-purple-400 hover:text-purple-700 hover:bg-purple-500/10"
          >
            <MessageSquare className="w-3 h-3 mr-1" />
            Feedback
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={handleBetaHubClick}
            className="text-xs text-purple-600 dark:text-purple-400 hover:text-purple-700 hover:bg-purple-500/10"
          >
            <Sparkles className="w-3 h-3 mr-1" />
            Beta Hub
          </Button>
        </div>
      </div>
    </div>
  );
}
